import React from 'react';
import android from "../Assets/images/android.png"
import apple from "../Assets/images/apple.png"

const SectionEight = () => {


    return(

            <div className='flex flex-col lg:flex-row  lg:items-end justify-center lg:mx-auto lg:w-maxWidth w-full pt-24 pb-24  lg:pt-24 gap-10 lg:gap-0 mx-auto'>
                <div className="w-full lg:p-0  p-4  flex flex-col gap-10 ">
                    <h2 className="font-axiforma text-2xl text-center lg:text-4xl font-light text-primary "><b className="font-bold">Download Now!</b></h2>
                    <h2 className="font-axiforma text-2xl text-center lg:text-4xl font-light text-primary ">And start accepting digital payments</h2>

                    <div className='w-full flex gap-4 items-center justify-center '>
                        <img className=' w-2/5 md:w-1/3  lg:w-1/4' src={android} alt={android} />
                        <img className=' w-2/5 md:w-1/3   lg:w-1/4' src={apple} alt={apple} />
                    </div>
                </div>
            </div>

    );
}

export  default SectionEight